export const issues = [
    'open',
    'in_progress',
    'closed'
];